const STORAGE_NAME = 'online-token';
const uniqid = require('uniqid');

export default function (Vue) {
    Vue.onlineToken = {
        set() {
            const uid = uniqid.time();
            window.sessionStorage.setItem(STORAGE_NAME, uid);
        },

        isExists() {
            const item = this.get();
            return Boolean(item);
        },

        get() {
            return window.sessionStorage.getItem(STORAGE_NAME);
        },

        destroy() {
            window.sessionStorage.removeItem(STORAGE_NAME);
        },
    }

    Object.defineProperties(Vue.prototype, {
        $onlineToken: {
            get() {
                return Vue.onlineToken;
            }
        }
    })
}